<template>
    <div class="wa-blast-list">
        <div class="m-d-16" v-for="data in dataList" :key="data.id">
            <SOSlotCard
                :id="`card-${data.id}`"
                :card-type="'shadow'"
                @loadMore="doLoadMore(data.id)"
                @toogleCard="toggleCard"
                :last-id="getLastId"
            >
                <template v-slot:before_head>
                    <div class="wa-device-container" @click="detail(data.id)">
                        <span class="f-regular f-12 f-c-midgrey wa-device">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.02664 1.33305C4.38664 1.33305 1.41997 4.29971 1.41997 7.93971C1.41997 9.10638 1.72664 10.2397 2.29997 11.2397L1.36664 14.6664L4.86664 13.7464C5.8333 14.273 6.91997 14.553 8.02664 14.553C11.6666 14.553 14.6333 11.5864 14.6333 7.94638C14.6333 6.17971 13.9466 4.51971 12.7 3.27305C12.0888 2.65566 11.3608 2.16616 10.5584 1.83308C9.75603 1.5 8.89538 1.33002 8.02664 1.33305ZM8.0333 2.44638C9.49997 2.44638 10.8733 3.01971 11.9133 4.05971C12.4237 4.56995 12.8284 5.17592 13.1041 5.84289C13.3798 6.50985 13.5211 7.22468 13.52 7.94638C13.52 10.973 11.0533 13.433 8.02664 13.433C7.03997 13.433 6.0733 13.173 5.2333 12.6664L5.0333 12.553L2.9533 13.0997L3.50664 11.073L3.3733 10.8597C2.8226 9.98549 2.53131 8.97293 2.5333 7.93971C2.53997 4.91305 4.99997 2.44638 8.0333 2.44638ZM5.68664 4.88638C5.57997 4.88638 5.39997 4.92638 5.24664 5.09305C5.09997 5.25971 4.66664 5.66638 4.66664 6.47305C4.66664 7.28638 5.25997 8.06638 5.3333 8.17971C5.42664 8.29305 6.50664 9.95971 8.16664 10.6664C8.55997 10.8464 8.86664 10.9464 9.10664 11.0197C9.49997 11.1464 9.85997 11.1264 10.1466 11.0864C10.4666 11.0397 11.12 10.6864 11.26 10.2997C11.4 9.91304 11.4 9.58638 11.36 9.51305C11.3133 9.44638 11.2066 9.40638 11.04 9.33305C10.8733 9.23971 10.06 8.83971 9.9133 8.78638C9.75997 8.73305 9.66664 8.70638 9.53997 8.86638C9.4333 9.03305 9.1133 9.40638 9.01997 9.51305C8.91997 9.62638 8.82664 9.63971 8.66664 9.55971C8.4933 9.47305 7.95997 9.29971 7.3333 8.73971C6.83997 8.29971 6.5133 7.75971 6.4133 7.59305C6.3333 7.43305 6.40664 7.33305 6.48664 7.25971C6.55997 7.18638 6.66664 7.06638 6.7333 6.96638C6.81997 6.87305 6.84664 6.79971 6.89997 6.69305C6.9533 6.57971 6.92664 6.48638 6.88664 6.40638C6.84664 6.33305 6.5133 5.50638 6.3733 5.17971C6.23997 4.85971 6.10664 4.89971 5.99997 4.89305C5.90664 4.89305 5.79997 4.88638 5.68664 4.88638Z"
                                    fill="#CCCCCC"
                                />
                            </svg>
                            {{ data.device.length > 1 ? data.device.length + " Perangkat" : data.device[0].nama }}
                        </span>
                    </div>
                </template>
                <template v-slot:card_head>
                    <div class="f-regular f-16 f-c-black m-t-10 m-d-4" @click="detail(data.id)">
                        <div class="d-flex-between-center">
                            <label class="m-d-0 nomore" v-if="!isSearch">{{ data.nama }}</label>
                            <label class="m-d-0 nomore" v-else v-html="searchHighlight(data.nama, search)"></label>
                            <div class="align-items-center">
                                <img src="@/assets/icons/chevron_right_4.svg" alt="" />
                            </div>
                        </div>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div @click="detail(data.id)">
                        <div class="f-regular f-13 f-c-midgrey">
                            Ke {{ data.total }} nomor •
                            {{
                                data.template.length > 1
                                    ? data.template.length + " template"
                                    : "Template " + data.template[0].nama
                            }}
                        </div>
                        <div class="f-regular f-13 f-c-midgrey p-d-10">
                            Tanggal blast: {{ $moment(data.created_at).format("DD MMM YYYY HH:mm") }}
                        </div>
                        <div v-if="data.reason && data.reason !== 'NoMoreData'">
                            <SOIconBase width="12" height="12" viewBox="0 0 18 17">
                                <template v-slot:icon>
                                    <WarningTriangle1817 icon-fill="#964040" />
                                </template>
                            </SOIconBase>
                            <label class="m-d-0 f-12 f-regular f-c-red m-l-4">
                                {{ data.reason }}
                            </label>
                        </div>
                    </div>

                    <div class="border-top" style="padding: 0 18px; margin: 0 -18px">
                        <div class="d-flex-between-center" v-if="!isFetching">
                            <div class="wa-blast-progress f-regular f-12 f-c-midgrey" style="padding: 6px 0">
                                <div v-if="data.finished_at === null && data.running === 2">
                                    <span
                                        class="spinner-border spinner-border-sm f-c-midgrey m-r-12"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Menyiapkan blast
                                </div>
                                <div v-if="data.finished_at === null && data.running === 1">
                                    <span
                                        class="spinner-border spinner-border-sm f-c-midgrey m-r-12"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Sedang memproses ({{ data.message_detail.progress }}/{{ data.total }}) pesan
                                </div>
                                <div v-if="data.finished_at === null && data.running === 0">
                                    Dijeda
                                </div>
                                <div v-if="data.finished_at !== null">
                                    Selesai {{ $moment(data.finished_at).format("DD MMM YYYY HH:mm") }}
                                </div>
                            </div>
                            <div
                                style="border-left: 1px solid #EDEDED; display: inherit"
                                v-if="data.finished_at === null && data.running !== 2 && validateAccess('whatsappBlast.update')"
                            >
                                <!-- play -->
                                <div
                                    class="p-x-8"
                                    style="padding: 6px 8px; border-right: 1px solid #EDEDED"
                                    v-if="data.running === 0"
                                    @click="mulai(data.id)"
                                >
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M6.66638 4.2832V15.9499L15.833 10.1165L6.66638 4.2832Z"
                                            fill="#6F7287"
                                        />
                                    </svg>
                                </div>
                                <!-- pause -->
                                <div
                                    class="p-x-8"
                                    style="padding: 6px 8px; border-right: 1px solid #EDEDED"
                                    v-if="data.running === 1"
                                    @click="jeda(data.id)"
                                >
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M5 15.8337H8.33333V4.16699H5V15.8337ZM11.6667 4.16699V15.8337H15V4.16699H11.6667Z"
                                            fill="#6F7287"
                                        />
                                    </svg>
                                </div>
                                <!-- stop -->
                                <div
                                    class="p-x-8"
                                    style="padding: 6px 8px; border-right: 1px solid #EDEDED"
                                    @click="hentikan(data.id)"
                                >
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M5 5H15V15H5V5Z" fill="#6F7287" />
                                    </svg>
                                </div>
                            </div>
                            <div v-if="data.finished_at !== null && data.from_socket === undefined">
                                <span class="wa-blast-status success"> {{ data.message_detail.sukses }} Terkirim </span>
                                <span class="wa-blast-status failed"> {{ data.message_detail.gagal }} Gagal </span>
                            </div>
                        </div>

                        <div v-else class="ph-row m-0 p-y-8 d-flex-between-center">
                            <div class="ph-col-4 big m-0"></div>
                            <div class="ph-col-4 big m-0"></div>
                        </div>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "./../store/state";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";
import resulter from "@/store/utils/resulter";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import WarningTriangle1817 from "@/so-components/global/icons/iconPacks/WarningTriangle1817.vue";

export default {
    name: "CardWABlast",
    components: {
        SOSlotCard,
        SOIconBase,
        WarningTriangle1817,
    },
    props: {
        dataList: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            pagination: "pagination",
            endItemofPage: "endItemofPage",
            totalHistory: "totalHistory",
            listHistoryTemp: "listHistoryTemp",

            search: "search",
            isSearch: "isSearch",
        }),
        getLastId() {
            return this.endItemofPage.id ? `card-${this.endItemofPage.id}` : "";
        },
    },
    data() {
        return {
            socketKey: "wablast.job.countprocessedmessage.",
            dataTemp: [],
        };
    },
    sockets: {
        connect: () => {
            console.log("socket connected");
        },
    },
    watch: {
        listHistoryTemp: {
            handler: function() {
                this.subscribeListBlast();
            },
        },
        dataList: function(nD, oD) {
            if (nD !== oD) {
                this.init();
            }
        },
    },
    mounted() {
        this.subscribeListBlastOnMounted();
    },
    methods: {
        ...mapActions({
            fetchListHistory: `${moduleName}/fetchListHistory`,
            setFetching: `${moduleName}/setFetching`,
            setLoadMore: `${moduleName}/setLoadMore`,
            toggleDisplayItem: `${moduleName}/toggleDisplayItem`,
            startBlast: `${moduleName}/startBlast`,
            pauseBlast: `${moduleName}/pauseBlast`,
            cancelBlast: `${moduleName}/cancelBlast`,
            resetListMessage: `${moduleName}/resetListMessage`,
        }),
        init() {
            let { dataList, subscribeStatusBlast } = this;
            dataList.forEach((data) => {
                if (!data.finished_at) {
                    subscribeStatusBlast(data.id);
                }
            });
        },

        mulai(id) {
            let form = new FormData();
            form.append("idblast", id);
            this.startBlast(form)
                .then((response) => {
                    if (response.data !== undefined) {
                        let { code, status, msg, data } = response.data;

                        if (status && code === 200) {
                            this.$toast.success(msg);
                            this.dataList.filter((data) => data.id === id)[0].running = 1;
                            this.subscribeIdBlast(id);
                            this.subscribeStatusBlast(id);
                            this.setFetching(false);
                        } else {
                            this.setFetching(false);
                            this.$toast.error(msg);
                        }
                    } else {
                        this.setFetching(false);
                        this.$toast.error(response);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
        jeda(id) {
            let form = new FormData();
            form.append("idblast", id);
            this.pauseBlast(form)
                .then((response) => {
                    let { code, status, msg, data } = response.data;

                    if (status && code === 200) {
                        this.$toast.success(msg);
                        this.dataList.filter((data) => data.id === id)[0].running = 0;
                        this.unsubscribeIdBlast(id);
                        this.sockets.unsubscribe(`wablast.job.status.${id}`);
                        this.setFetching(false);
                    } else {
                        this.setFetching(false);
                        this.$toast.error(msg);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
        hentikan(id) {
            let form = new FormData();
            form.append("idblast", id);
            this.cancelBlast(form)
                .then((response) => {
                    let { code, status, msg, data } = response.data;

                    if (status && code === 200) {
                        this.$toast.success(msg);
                        this.dataList.filter((data) => data.id === id)[0].running = 0;
                        this.dataList.filter((data) => data.id === id)[0].finished_at = this.$moment().format(
                            "YYYY-MM-DD HH:mm:ss"
                        );
                        this.unsubscribeIdBlast(id);
                        this.sockets.unsubscribe(`wablast.job.status.${id}`);
                        this.setFetching(false);
                    } else {
                        this.setFetching(false);
                        this.$toast.error(msg);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },

        async doLoadMore(dataId) {
            if (this.totalHistory > this.pagination.length) {
                if (!this.isFetching && this.getLastId === `card-${dataId}`) {
                    await this.setLoadMore(true);
                    await this.fetchListHistory();
                    setTimeout(() => {
                        $(".card").css({ "padding-bottom": "0" });
                    }, 500);
                }
            }
        },
        toggleCard(data) {
            this.toggleDisplayItem(data);
        },

        updateProgressBlast(id, report) {
            let index = this.dataList.findIndex((data) => data.id === id);
            this.dataList[index].message_detail.progress = report;
            if (this.dataList[index].total === parseInt(this.dataList[index].message_detail.progress)) {
                this.dataList[index].running = 0;
                this.dataList[index].finished_at = this.$moment();
                this.dataList[index].from_socket = true;
            }
        },
        subscribeStatusBlast(id) {
            let idx = this.dataList.findIndex((data) => data.id === id);
            this.sockets.subscribe(`wablast.job.status.${id}`, (status) => {
                if (status === "BlastDone") {
                    this.dataList[idx].finished_at = this.$moment().format("YYYY-MM-DD HH:mm:ss");
                    this.sockets.unsubscribe(`wablast.job.status.${id}`);
                } else if (status === "SetupDone") {
                    this.dataList[idx].finished_at = null;
                    this.dataList[idx].running = 0;
                } else if (status === "BlastStart") {
                    this.dataList[idx].finished_at = null;
                    this.dataList[idx].running = 1;
                }
            });
        },

        subscribeListBlast() {
            this.dataTemp = JSON.parse(JSON.stringify(this.listHistoryTemp));
            setTimeout(() => {
                if (this.dataTemp.length > 0) {
                    this.dataTemp.forEach((v) => {
                        if (v.finished_at === null && v.running === 1) {
                            this.sockets.subscribe(this.socketKey + v.id, async (report) => {
                                await this.updateProgressBlast(v.id, parseInt(report));
                            });
                        }
                    });
                }
            }, 2000);
        },
        subscribeListBlastOnMounted() {
            this.dataList.forEach((v) => {
                if (v.finished_at === null && v.running === 1) {
                    this.sockets.subscribe(this.socketKey + v.id, async (report) => {
                        await this.updateProgressBlast(v.id, parseInt(report));
                    });
                }
            });
        },
        subscribeIdBlast(id) {
            this.sockets.subscribe(this.socketKey + id, async (report) => {
                await this.updateProgressBlast(v.id, parseInt(report));
            });
        },
        unsubscribeListBlast() {
            this.dataList.forEach((v) => {
                this.sockets.unsubscribe(this.socketKey + v.id);
            });
        },
        unsubscribeIdBlast(id) {
            this.sockets.unsubscribe(this.socketKey + id);
        },

        detail(id) {
            this.resetListMessage();
            this.$router.push({ name: "wa_blast.detail.index", params: { id: id } });
        },
    },
    beforeDestroy() {
        this.unsubscribeListBlast();
    },
};
</script>

<style scoped>
.wa-device-container {
    margin: -10px 0 0 -18px;
}

.wa-device {
    background: #f6f6f6;
    border-top-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    padding: 4px 8px;
    max-width: 200px;

    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.wa-blast-progress {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 70%;
}

.wa-blast-status {
    padding: 2px 4px;
    border-radius: 4px;
    margin: 0 3px;
}

.wa-blast-status.success {
    background-color: #e8fcee;
    color: #40964c;
}

.wa-blast-status.failed {
    background-color: #fff1f1;
    color: #964040;
}
</style>
